import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { Doctor } from './doctor.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DoctorAddressComponent } from './doctor-address.component';
import { MatTable } from '@angular/material/table';
import { DoctorAddress } from './doctor-address.interface';
import { DoctorPoc } from "./poc.interface";
import { PocComponent } from './poc.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SnackbarService } from '../../snackbar.service';
import { CommonDropdownService } from '../../common-dropdown.service';
import { environment } from "../../../../environments/environment"
import { MatSelect } from '@angular/material/select';
import { tap, filter, finalize } from 'rxjs/operators';
import { Company } from '../company/company.interface';


@Component({
    selector: 'doctor-form',
    templateUrl: './doctor.form.component.html',
    styleUrls: ['./doctor.form.component.css']
})
@Injectable({
    providedIn: 'root'
})
export class DoctorFormComponent implements OnInit {

    @ViewChild('addr_table') addr_table: MatTable<any>;
    @ViewChild('poc_table') poc_table: MatTable<any>;
    @ViewChild('city_id', { static: false }) city_id: MatSelect;// for dropdown
    @ViewChild('state_id', { static: false }) state_id: MatSelect;// for dropdown
    @ViewChild('sales_person_id', { static: false }) sales_person_id: MatSelect;// for dropdown
    @ViewChild('pricelist_id', { static: false }) pricelist_id: MatSelect;// for dropdown
    @ViewChild('company_id', { static: false }) company_id: MatSelect;

    constructor(    
        private route: ActivatedRoute,
        private api: CommonApiService,
        private dialog: MatDialog,
        private router: Router,
        private snackbar: SnackbarService,
        private dropdownService: CommonDropdownService
    ) { }

    public model = 'doctor'
    public doctor = {} as Doctor;
    addressDisplayedColumns: string[] = ['address_line_1', 'city', 'pincode', 'state'];
    addressDataSource:any = []
    pocDisplayedColumns: string[] = ['name', 'email', 'designation', 'mobile'];
    pocDataSource:any = [];

    isFormDisabled = true;
    result: string;
    onSaveDisable = false;

    companySearchPage=0
    allCompaniesCount = 0
    public allCompanies: any[] = [];
    public selectedCompany: number;
    public selectedCompanyObject: Company[] = [];

    citySearchPage = 0;
    allCitiesCount = 0
    public allCities: any[] = [];
    public selectedCityObject: any[] = [];
    public selectedCity: number;

    stateSearchPage = 0;
    allStatesCount = 0
    public allStates: any[] = [];
    public selectedStateObject: any[] = [];
    public selectedState: number;

    salesPersonSearchPage = 0;
    allSalesPersonCount = 0
    public allSalesPerson: any[] = [];
    public selectedSalesPersonObject: any[] = [];
    public selectedSalesPerson: number;

    priceListSearchPage = 0;
    allPriceListCount = 0
    public allPriceLists: any[] = [];
    public selectedPriceListObject: any[] = [];
    public selectedPriceList: number;

    // Communication / Recovery person (employees, optional)
    public allCommunicationPersons: any[] = [];
    public filteredCommunicationPersons: any[] = [];
    public selectedCommunicationPerson: number | null = null;

    public allRecoveryPersons: any[] = [];
    public filteredRecoveryPersons: any[] = [];
    public selectedRecoveryPerson: number | null = null;

    ngOnInit() {
        let doctorId = this.route.snapshot.params.id
        if (doctorId === 'create') {
            this.isFormDisabled = false;
        }
        else {
            this.api.refreshNeeded.subscribe(() => {
                this.getDoctor(Number(doctorId));
            });
            this.getDoctor(Number(doctorId));
        }
        this.onLoadCityList();
        this.onLoadStateList();
        this.onLoadSalesPersonList();
        this.onLoadPriceListList();
        this.OnLoadCompanyList();
        this.loadEmployeesForPersons();
    }

    loadEmployeesForPersons() {
        this.api.getAll('employee').subscribe((res: any) => {
            const list = res || [];
            this.allCommunicationPersons = list;
            this.filteredCommunicationPersons = list;
            this.allRecoveryPersons = list;
            this.filteredRecoveryPersons = list;
        });
    }

    onCommunicationPersonKey(event: Event) {
        const value = (event.target as HTMLInputElement).value.toLowerCase();
        this.filteredCommunicationPersons = this.allCommunicationPersons.filter(
            e => (e.name || '').toLowerCase().includes(value),
        );
    }

    onRecoveryPersonKey(event: Event) {
        const value = (event.target as HTMLInputElement).value.toLowerCase();
        this.filteredRecoveryPersons = this.allRecoveryPersons.filter(
            e => (e.name || '').toLowerCase().includes(value),
        );
    }

     //api call to bring search values in dropdown and also the selected value in dropdown is displayed
     onCityKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'area', this.allCities, this.selectedCityObject, 'citySearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allCities = result.entityList;
            this.citySearchPage = result.pageVariable;
        });
    }

    // On scroll of dropdown api call to fetch next records
    onCityScroll(event:any) {
        if (event) {
            if (!this.city_id?.panel || !this.city_id?.panel.nativeElement) {
                // Panel or nativeElement is not available, return or handle the situation accordingly.
                return;
            }
            this.city_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                if (!this.city_id?.panel?.nativeElement) return;
                const tolerance = 10
                if (
                    Math.floor(this.city_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.city_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.city_id.panel.nativeElement.offsetHeight)
                ){
                    let cityparams = {
                        'pageIndex': this.citySearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }

                    if (this.allCities.length >= this.allCitiesCount) {
                        return;
                    }
                    this.api.postAll('area/list/display', cityparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedCityObject[0]?.id);
                        this.allCities.push(...res.items);
                    });
                    this.citySearchPage++;// send page number for fetching the records 
                }
            });
        }
    }

    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadCityList() {
        let params = {
            'pageIndex': this.citySearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }

        this.api.postAll('area/list/display', params).pipe(
            tap((res: any) => {
              this.allCities.push(...res.items);
              this.allCitiesCount = res.rowCount
            }),
            filter(() => this.selectedCityObject.length !== 0),
            tap(() => {
              const selectedCityId = this.selectedCityObject[0].id;
              this.allCities = this.allCities.filter(city => city.id !== selectedCityId);
              this.allCities.unshift(this.selectedCityObject[0]);
              
            }),
            finalize(() => this.citySearchPage++)
        ).subscribe();
    }

    onSalesPersonKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'employee', this.allSalesPerson, this.selectedStateObject, 'salesPersonSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allSalesPerson = result.entityList;
            this.salesPersonSearchPage = result.pageVariable;
        });
    }

    //api call to bring search values in dropdown and also the selected value in dropdown is displayed
    onStateKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'state', this.allStates, this.selectedStateObject, 'stateSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allStates = result.entityList;
            this.stateSearchPage = result.pageVariable;
        });
    }

    // On scroll of dropdown api call to fetch next records
    onStateScroll(event:any) {
        if (event) {
            if (!this.state_id?.panel || !this.state_id?.panel.nativeElement) {
                // Panel or nativeElement is not available, return or handle the situation accordingly.
                return;
            }
            this.state_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                if (!this.state_id?.panel?.nativeElement) return;
                const tolerance = 10
                if (
                    Math.floor(this.state_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.state_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.state_id.panel.nativeElement.offsetHeight)
                ){
                    let stateparams = {
                        'pageIndex': this.stateSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }

                    if (this.allStates.length >= this.allStatesCount) {
                        return;
                    }
                    this.api.postAll('state/list/display', stateparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedStateObject[0]?.id);
                        this.allStates.push(...res.items);
                    });
                    this.stateSearchPage++;// send page number for fetching the records
                }
            });
        }
    }

    onSalesPersonScroll(event:any) {
        if (event) {
            if (!this.sales_person_id?.panel || !this.sales_person_id?.panel.nativeElement) {
                // Panel or nativeElement is not available, return or handle the situation accordingly.
                return;
            }
            this.sales_person_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                if (!this.sales_person_id?.panel?.nativeElement) return;
                const tolerance = 10
                if (
                    Math.floor(this.sales_person_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.sales_person_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.sales_person_id.panel.nativeElement.offsetHeight)
                ){
                    let salesPersonparams = {
                        'pageIndex': this.stateSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
    
                    if (this.allSalesPerson.length >= this.allSalesPersonCount) {
                        return;
                    }
                    this.api.postAll('employee/list/display', salesPersonparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedSalesPersonObject[0]?.id);
                        this.allSalesPerson.push(...res.items);
                    });
                    this.salesPersonSearchPage++;// send page number for fetching the records
                }
            });
        }
    }

    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadStateList() {
        let params = {
            'pageIndex': this.stateSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }

        this.api.postAll('state/list/display', params).pipe(
            tap((res: any) => {
              this.allStates.push(...res.items);
              this.allStatesCount = res.rowCount
            }),
            filter(() => this.selectedStateObject.length !== 0),
            tap(() => {
              const selectedStateId = this.selectedStateObject[0].id;
              this.allStates = this.allStates.filter(state => state.id !== selectedStateId);
              this.allStates.unshift(this.selectedStateObject[0]);
              
            }),
            finalize(() => this.stateSearchPage++)
        ).subscribe();
    }

    onLoadSalesPersonList() {
        let params = {
            'pageIndex': this.salesPersonSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }
    
        this.api.postAll('employee/list/display', params).pipe(
            tap((res: any) => {
              this.allSalesPerson.push(...res.items);
              this.allSalesPersonCount = res.rowCount
            }),
            filter(() => this.selectedSalesPersonObject.length !== 0),
            tap(() => {
              const selectedSalesPersonId = this.selectedSalesPersonObject[0].id;
              this.allSalesPerson = this.allSalesPerson.filter(salesPerson => salesPerson.id !== selectedSalesPersonId);
              this.allSalesPerson.unshift(this.selectedSalesPersonObject[0]);
              
            }),
            finalize(() => this.salesPersonSearchPage++)
        ).subscribe();
    }

    //api call to bring search values in dropdown and also the selected value in dropdown is displayed
    onPriceListKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'pricelist', this.allPriceLists, this.selectedPriceListObject, 'priceListSearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allPriceLists = result.entityList;
            this.priceListSearchPage = result.pageVariable;
        });
    }

    // On scroll of dropdown api call to fetch next records
    onPriceListScroll(event:any) {
        if (event) {
            if (!this.pricelist_id?.panel || !this.pricelist_id?.panel.nativeElement) {
                // Panel or nativeElement is not available, return or handle the situation accordingly.
                return;
            }
            this.pricelist_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                if (!this.pricelist_id?.panel?.nativeElement) return;
                const tolerance = 10
                if (
                    Math.floor(this.pricelist_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.pricelist_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.pricelist_id.panel.nativeElement.offsetHeight)
                ){
                    let pricelistparams = {
                        'pageIndex': this.priceListSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }

                    if (this.allPriceLists.length >= this.allPriceListCount) {
                        return;
                    }
                    this.api.postAll('pricelist/list/display', pricelistparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedPriceListObject[0]?.id);
                        this.allPriceLists.push(...res.items);
                    });
                    this.priceListSearchPage++;// send page number for fetching the records
                }
            });
        }
    }

    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadPriceListList() {
        let params = {
            'pageIndex': this.priceListSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }

        this.api.postAll('pricelist/list/display', params).pipe(
            tap((res: any) => {
              this.allPriceLists.push(...res.items);
              this.allPriceListCount = res.rowCount
            }),
            filter(() => this.selectedPriceListObject.length !== 0),
            tap(() => {
              const selectedPriceListId = this.selectedPriceListObject[0].id;
              this.allPriceLists = this.allPriceLists.filter(pricelist => pricelist.id !== selectedPriceListId);
              this.allPriceLists.unshift(this.selectedPriceListObject[0]);
              
            }),
            finalize(() => this.priceListSearchPage++)
        ).subscribe();
    }

    getDoctor(doctorId: number) {
        this.api.get(this.model, doctorId).subscribe(
            (data: any) => {
                if (data) {
                    this.doctor = data;
                    this.addressDataSource = data.doctor_addresses ? data.doctor_addresses : []
                    this.pocDataSource = data.pocs ? data.pocs : []
                    
                    if(data.company){
                        this.selectedCompany = data.company.id;
                        this.allCompanies = this.allCompanies.filter(company => company.id !== data.company.id);
                        this.allCompanies.push(data.company) // insert specific selected into the dropdown list
                        this.selectedCompanyObject.push(data.company)
                    }

                    if(data.city){
                        this.selectedCity = data.city.id;
                        this.allCities = this.allCities.filter(city => city.id !== data.city.id);
                        this.allCities.push(data.city) // insert specific selected into the dropdown list
                        this.selectedCityObject.push(data.city)
                    }
                    if(data.state){
                        this.selectedState = data.state.id;
                        this.allStates = this.allStates.filter(state => state.id !== data.state.id);
                        this.allStates.push(data.state) // insert specific selected into the dropdown list
                        this.selectedStateObject.push(data.state)
                    }
                    if(data.employee){
                        this.selectedSalesPerson = data.employee.id;
                        this.allSalesPerson = this.allSalesPerson.filter(employee => this.sales_person_id.id !== data.employee.id);
                        this.allSalesPerson.push(data.employee) // insert specific selected into the dropdown list
                        this.selectedSalesPersonObject.push(data.employee)
                    }
                    if(data.pricelist){
                        this.selectedPriceList = data.pricelist.id;
                        this.allPriceLists = this.allPriceLists.filter(pricelist => pricelist.id !== data.pricelist.id);
                        this.allPriceLists.push(data.pricelist) // insert specific selected into the dropdown list
                        this.selectedPriceListObject.push(data.pricelist)
                    }
                    this.selectedCommunicationPerson = data.communication_person_id ?? null;
                    this.selectedRecoveryPerson = data.recovery_person_id ?? null;
                }
            }
        );
    }

    save(formValid:any) {
        if(formValid == false){
            this.snackbar.warning("Please fill mandatory fields.");
            return;
        }
        if(this.selectedCity == undefined){
            this.snackbar.warning("Please select city.");
            return;
        }
        if(this.selectedState == undefined){
            this.snackbar.warning("Please select state.");
            return;
        }
        this.onSaveDisable = true;
        this.doctor.city_id = this.selectedCity;
        this.doctor.state_id = this.selectedState;
        this.doctor.sales_person_id = this.selectedSalesPerson
        this.doctor.pricelist_id = this.selectedPriceList;
        this.doctor.linked_company_id=this.selectedCompany
        this.doctor.communication_person_id = this.selectedCommunicationPerson ?? undefined;
        this.doctor.recovery_person_id = this.selectedRecoveryPerson ?? undefined;

        this.api.createUpdate(this.model, this.doctor).subscribe(
            (data: any) => {
                if (data) {
                    this.doctor = data;
                    this.isFormDisabled = true;
                    this.snackbar.success('Saved Successfully!');
                    this.router.navigate([`/${this.model}/${data.id}`])
                    this.onSaveDisable = false;
                }
            },
            error => {
                this.snackbar.error(error.error.message)
                this.onSaveDisable = false;
            }
        );
    }

    openDialog(activeAddress: any) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            uid: activeAddress.id,
            doctorId: this.doctor.id,
            address: activeAddress
        }
        const dialogRef = this.dialog.open(DoctorAddressComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.addDoctorAddress(result.doctorAddress, activeAddress);
            }
          });

    }
    openDialogPoc(activePoc: any) {
        const dialogConfigPoc = new MatDialogConfig();
        dialogConfigPoc.data = {
            uid: activePoc.id,
            doctorId: this.doctor.id,
            poc: activePoc
        }
        
        const dialogRefPoc = this.dialog.open(PocComponent, dialogConfigPoc);

        dialogRefPoc.afterClosed().subscribe(result => {
            if (result) {
                this.addDoctorPoc(result.doctorPoc, activePoc);
            }
        });
    }

    addDoctorPoc(poc: DoctorPoc, activePoc: any) {
        var replaced1 = false
        for (let i = 0; i < this.pocDataSource.length; i++) {
            if (this.pocDataSource[i] == activePoc) {
                this.pocDataSource[i] = poc
                replaced1 = true
                break
            }
        }
        if (!replaced1) {
            this.pocDataSource.push(poc);
        }
        this.doctor.pocs = this.pocDataSource
        this.poc_table?.renderRows(); 
    }


    addDoctorAddress(address: DoctorAddress, activeAddress: any) {
        var replaced = false
        for (let i = 0; i < this.addressDataSource.length; i++) {
            if (this.addressDataSource[i] == activeAddress) {
                this.addressDataSource[i] = address
                replaced = true
                break
            }
        }
        if (!replaced) {
            this.addressDataSource.push(address);
        }
        this.doctor.doctor_addresses = this.addressDataSource
        this.addr_table?.renderRows();
    }

    edit(){
        this.isFormDisabled = false;
    }

    discardChanges(): void {
		const message = `Are you sure you want to discard the changes?`
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: "Discard Changes",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
                if(this.doctor.id){
                    this.isFormDisabled = true;
                    this.getDoctor(this.doctor.id);
                }else{
                    this.router.navigate([`/doctor`]);
                }
			}
		});
	}

    create(){
        this.redirectTo('doctor/create');
    }

    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

    OnLoadCompanyList() {
        this.api.getAll('company').pipe(
            tap((res: any) => {
                this.allCompanies=res
            }),
            filter(() => this.selectedCompanyObject.length !== 0),
            tap(() => {
              const selectedCompanyId = this.selectedCompanyObject[0].id;
              this.allCompanies = this.allCompanies.filter(company => company.id !== selectedCompanyId);
              this.allCompanies.unshift(this.selectedCompanyObject[0]);
              
            }),
        ).subscribe();
    }

    OnCompanyKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'company', this.allCompanies, this.selectedCompanyObject, 'companySearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            
            this.allCompanies = result.entityList;
            this.companySearchPage = result.pageVariable;
        });
    }

    OnCompanyScroll(event:any) {
        if (!this.company_id?.panel || !this.company_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.company_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                if (!this.company_id?.panel?.nativeElement) return;
                const tolerance = 10
                if (
                    Math.floor(this.company_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.company_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.company_id.panel.nativeElement.offsetHeight)
                    ){
                    let companyparams = {
                        'pageIndex': this.companySearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allCompanies.length >= this.allCompaniesCount) {
                        return;
                    }
                    this.api.postAll('company/list/display', companyparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedCompanyObject[0]?.id);
                        this.allCompanies.push(...res.items);
                    });
                    this.companySearchPage++;// send page number for fetching the records
                }
            });
        }
    }

}
